import { render, staticRenderFns } from "./FollowCraftList.vue?vue&type=template&id=1608e6ce&scoped=true"
import script from "./FollowCraftList.vue?vue&type=script&lang=js"
export * from "./FollowCraftList.vue?vue&type=script&lang=js"
import style0 from "./FollowCraftList.vue?vue&type=style&index=0&id=1608e6ce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608e6ce",
  null
  
)

export default component.exports